// src/App.tsx — page wrapper around the LLABARO device.
import Llabaro from "./components/Llabaro";
import { AI_STUDIO_URL } from "./config";

export default function App() {
  return (
    <>
      <Llabaro />
      <a
        className="byok-link"
        href={AI_STUDIO_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        BYOK Gemini API | ZeroLogin
      </a>
    </>
  );
}
